module.exports = __webpack_public_path__ + "static/media/programming.0b2af822.svg";